define(['jquery', 'jquery.transit', 'modernizr', 'container', 'router', 'jump',
    'module-brand-solution-video-content-featured'],
    function ($, transit, modernizr, container, router, jumpFactory, moduleBrandSolutionVideoContentFeatured) {

        return (function () {

            const name = 'brand-solution-video-content';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const jump = jumpFactory.create();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                items: new Map(),
                canNavigateAction: 0,
                currentMenuItem: 'brand-solution-video-content-featured',
                targetSection: '',
                itemsKeys: [],
            };

            view.startup = function () {

                view.privateVars.items.set('brand-solution-video-content-featured', {
                    init: false,
                    module: moduleBrandSolutionVideoContentFeatured,
                    config: view.publicVars.moduleBrandSolutionVideoContentFeaturedConfig,
                    callbacks: {

                    }
                });

                view.privateVars.itemsKeys.push('brand-solution-video-content-featured');

                view.methods.handleCurrentScrollPosition({ startup: 1 });

                for (let [key, value] of view.privateVars.items) {
                    const systemCurrentScroll = $(document).scrollTop();
                    var targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                    view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);
                }
            };

            view.bind = function () {

                $(window).on('beforeunload', function () {
                    if (view.privateVars.currentMenuItem != '') {

                        let pos;
                        pos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + view.privateVars.currentMenuItem).offset();
                        //window.history.replaceState({}, "", "#");

                        let modifier = 0;

                        const windowWidth = $(window).width();

                        if(view.privateVars.currentMenuItem !== 'brand-solution-video-content-featured' && windowWidth < 1025 && windowWidth > 850) {
                            modifier = -62;
                        } else if(view.privateVars.currentMenuItem !== 'brand-solution-video-content-featured' && windowWidth < 851 && windowWidth > 0) {
                            modifier = -52;
                        }

                        $(window).scrollTop((pos.top + modifier));
                    }
                });


                $(window).scroll(function () {

                    let ticking = false;

                    if (view.privateVars.canNavigateAction === 0) {

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                view.methods.handleCurrentScrollPosition();
                                ticking = false;
                            });
                        }
                        ticking = true;
                    }
                });

                $(window).resize(() => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(view.publicVars.cssId.layout.canNavigateCls).click(function () {
                    var target = container.getData($(this)[0], 'target');

                    container.msg('system - navigate target ' + target);

                    view.methods.performNavigate(target, {fireAnim: 1 });
                });

                /* BTODO set minimum height value that supports scroll browsing currently 700 */
                if($(window).width() > 1024 && $('body').hasClass(view.publicVars.cssId.layout.bodyDesktopCls.substr(1)) &&
                    $(window).outerHeight() > 699) {


                    document.addEventListener("mousewheel", function (event) {
                        if($(window).width() > 1024 && $(window).outerHeight() > 699) {
                            view.methods.handleMouseScrollWrapper(event);
                        }
                    }, { passive: false });

                    document.addEventListener("DOMMouseScroll", function (event) {
                        if($(window).width() > 1024 && $(window).outerHeight() > 699) {
                            view.methods.handleMouseScrollWrapper(event);
                        }
                    }, { passive: false });


                    // $(window).bind('mousewheel DOMMouseScroll', function (event) {
                    //
                    //     event.preventDefault();
                    //     event.stopPropagation();
                    //
                    //     if (view.privateVars.canNavigateAction === 0) {
                    //         view.methods.handleMouseScroll(event);
                    //     } else {
                    //         event.preventDefault();
                    //         event.stopPropagation();
                    //         return false;
                    //     }
                    //
                    //     return false;
                    // });
                }

            };

            view.methods = {

                handleMouseScrollWrapper: (event) => {
                    if (view.privateVars.canNavigateAction === 0) {
                        view.methods.handleMouseScroll(event);
                    } else {
                        event.preventDefault();
                    }
                },

                handleMouseScroll: (event) => {

                    const systemWindowHeight = $(window).outerHeight();
                    const systemCurrentScroll = $(document).scrollTop();

                    const moduleHeight = $(view.publicVars.cssId.layout.navigateTargetId + '-' + view.privateVars.currentMenuItem).outerHeight();
                    const rect = $(view.publicVars.cssId.layout.navigateTargetId + '-' + view.privateVars.currentMenuItem)[0].getBoundingClientRect();

                    const arr = [...view.privateVars.items.keys()];

                    if (event.wheelDelta > 0 || event.detail < 0) {

                        if (rect.top >= 0) {

                            const prevIndex = arr.indexOf(view.privateVars.currentMenuItem) - 1;

                            if(prevIndex >= 0) {
                                view.methods.performNavigate(arr[prevIndex], {fireAnim: 1 });

                                event.preventDefault();
                            } else {
                                view.methods.scrollFluent(event);
                            }
                        } else {
                            view.methods.performNavigate(view.privateVars.currentMenuItem, {fireAnim: 1 });
                            event.preventDefault();
                        }
                    } else {

                        const nextIndex = arr.indexOf(view.privateVars.currentMenuItem) + 1;

                        if (rect.bottom <= systemWindowHeight) {
                            if (nextIndex < arr.length) {
                                view.methods.performNavigate(arr[nextIndex], {fireAnim: 1});
                                event.preventDefault();
                            } else {
                                // view.methods.scrollFluent(event);
                                view.methods.performNavigate('footer', {fireAnim: 1, moveOnly: 1});
                                event.preventDefault();
                            }
                        } else {
                            view.methods.scrollFluent(event);
                        }
                    }
                },

                scrollFluent: (event) => {

                },

                handleCurrentScrollPosition: (options) => {

                    const systemCurrentScroll = $(document).scrollTop();

                    let currentMenu = '';

                    for (let [key, value] of view.privateVars.items) {

                        if(systemCurrentScroll == 0) {
                            currentMenu = key;
                            break;
                        }

                        const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                        view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);

                        let modifier = 200;

                        if ((targetPos.top - modifier) < systemCurrentScroll) {
                            currentMenu = key;
                        }
                    }

                    if (view.privateVars.currentMenuItem !== currentMenu && currentMenu !== '') {
                        view.privateVars.currentMenuItem = currentMenu;
                    }
                },

                handleModuleInit: (currentScroll, key, targetPos) => {

                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                        const rect = $(view.publicVars.cssId.layout.navigateWrapperTargetId + '-' + key)[0].getBoundingClientRect();
                        const scrollPlusWindowHeight = $(window).height() + currentScroll;

                        if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height))) {

                            view.methods.fireModuleStart(key);
                        }
                    }

                },

                fireModuleStart: (key) => {
                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {

                        view.privateVars.items.get(key).init = true;
                        view.privateVars.items.get(key).module.init(
                            view.privateVars.items.get(key).config,
                            view.privateVars.items.get(key).callbacks
                        );
                    }
                },

                performNavigate: (target, options) => {

                    view.privateVars.targetSection = target;

                    if(!options.moveOnly) {
                        view.methods.fireModuleStart(target);
                    }

                    $('html, body').finish();

                    let easing = (options && options.easing) || 'easeInOutExpo';

                    const masterSpeed = (options && options.speed !== undefined && options.speed >= 0) ? options.speed : '';

                    const modifier = '0';
                    var speed = 0;

                    let shouldFireAnim = (options && options.fireAnim) || 0;

                    view.privateVars.canNavigateAction = 1;

                    const systemCurrentScroll = $(document).scrollTop();

                    let targetPos;

                    if(options.detailedJumpTarget) {
                        targetPos = $(options.detailedJumpTarget).offset();
                    } else {
                        targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + target).offset();
                    }


                    var diff = Math.abs(systemCurrentScroll - targetPos.top);

                    if (diff > 1000) {
                        speed = 800 + (diff / 3);

                    } else {
                        speed = 1000;
                    }

                    container.msg('system - diff for navigation ' + diff);

                    if (masterSpeed !== '') {
                        speed = masterSpeed;
                    }

                    container.msg('system - navigation anim speed ' + speed);

                    if (target == view.privateVars.currentMenuItem) {
                        shouldFireAnim = 0;
                    } else {
                        // $(view.publicVars.cssId.layout.headerMenuItemCls).removeClass(view.publicVars.cssId.layout.isActiveCls.substr(1));
                    }

                    if (shouldFireAnim) {
                        if (Modernizr.mq('screen and (max-width: 1024px)')) {
                        } else {
                            //view.methods.performAnim(target, view.privateVars.currentMenuItem, {speed: speed});
                        }
                    }

                    let jumpTarget;
                    let jumpMethod;

                    if(options.detailedJumpTarget) {
                        jumpTarget = options.detailedJumpTarget;
                        jumpMethod = jump.centerTo;
                    } else {
                        jumpTarget = view.publicVars.cssId.layout.navigateTargetId + '-' + target;
                        jumpMethod = jump.jumpTo;
                    }

                    jumpMethod(jumpTarget, {
                        modifier: modifier,
                        easing: easing,
                        speed: speed
                    }, function () {

                        if(options.finishCallback) {
                            options.finishCallback();
                        }

                        // $(view.publicVars.cssId.layout.headerMenuItemCls).removeClass(view.publicVars.cssId.layout.isActiveCls.substr(1));

                        // $('#' + view.publicVars.cssId.layout.headerMenuItemCls.substr(1) + '-' + target)
                        //     .addClass(view.publicVars.cssId.layout.isActiveCls.substr(1));

                        view.privateVars.canNavigateAction = 0;
                        view.privateVars.targetSection = '';

                        if (view.privateVars.currentMenuItem !== target && !options.moveOnly) {
                            view.privateVars.currentMenuItem = target;
                        }

                        if (shouldFireAnim) {
                            if (Modernizr.mq('screen and (max-width: 1024px)')) {
                            } else {
                                //view.methods.performPostAnim(target, view.privateVars.currentMenuItem, {speed: speed});
                            }
                        }
                    });
                }
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
